import type { ContentFitnessAssessmentMode } from "../../../enums/content-fitness";
import type { ContentFitnessDimensionKey } from "../dimensions";
import { CONTENT_FITNESS_FRAMEWORK_VERSION } from "../version";

type AnchorMap = Record<0 | 1 | 2 | 3 | 4, string>;

export type ContentFitnessSubcriterion = {
  key: string;
  version: typeof CONTENT_FITNESS_FRAMEWORK_VERSION;
  label: string;
  parentMetricKey: ContentFitnessDimensionKey;
  order: number;
  assessmentMode: ContentFitnessAssessmentMode;
  pilot: boolean;
  definition: string;
  evidenceGuidance: string;
  applicabilityNotes: string;
  anchors: AnchorMap | null;
  objectiveChecks: readonly string[];
};

/** Builds the 0-4 anchor descriptions for a rubric or hybrid subcriterion. */
export const anchors = (
  zero: string,
  one: string,
  two: string,
  three: string,
  four: string,
): AnchorMap => ({
  0: zero,
  1: one,
  2: two,
  3: three,
  4: four,
});

/**
 * A canonical subcriterion kept in the taxonomy for the denominator and future
 * implementation, but not scored in the current pilot.
 */
export const deferred = (
  key: string,
  label: string,
  parentMetricKey: ContentFitnessDimensionKey,
  order: number,
  assessmentMode: ContentFitnessAssessmentMode,
  definition: string,
): ContentFitnessSubcriterion => ({
  key,
  version: CONTENT_FITNESS_FRAMEWORK_VERSION,
  label,
  parentMetricKey,
  order,
  assessmentMode,
  pilot: false,
  definition,
  evidenceGuidance:
    "Canonical taxonomy item retained for denominator and future implementation; not scored in the current pilot.",
  applicabilityNotes:
    "Deferred from the pilot. Do not require this result for current Yeet completion or present it as measured.",
  anchors: null,
  objectiveChecks: [],
});
